import React, { Component } from 'react';
import { H1, H3, H5, P, Subtitle, NextBtn, Highlights, Tag, Title} from '../css/fonts.js';
import { OuterContainer, ShContainer, WholeRow, OuterFlexBox} from '../css/container.js';
import { kloaContent } from '../content.js';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Image from '../components/Image';
import { CgArrowLongRight } from "react-icons/cg";


class Kloa extends Component {
  render() {
    return (
      <div>
      <OuterContainer>
        <ShContainer>
        <Navbar/>
        <br/><br/><br/><br/>
        <WholeRow>
          <img src={kloaContent.logoimg} alt={kloaContent.logoimg} style={{"width":"25%"}}/>
        </WholeRow>
        <WholeRow>
          <Subtitle theme={{color:"#EE0800"}}>Overview</Subtitle>
          <H5 dangerouslySetInnerHTML={{ __html: kloaContent.overview }}/>
        </WholeRow>
        <WholeRow>
          <Subtitle theme={{color:"#EE0800"}}>Impacts</Subtitle>
          <H5 dangerouslySetInnerHTML={{ __html: kloaContent.impact }}/>
          <H5><a href="https://docs.google.com/presentation/d/1VzwkIir7AG1nIT7N8f8PSCRvmR2Q4mW6GjGLa-thX0g/edit#slide=id.g21389358991_0_62">For more details, please click here to get access.</a></H5>
        </WholeRow>



        {/**<WholeRow>
          <Subtitle theme={{color:"#EE0800"}}>Challenges</Subtitle>
          <H5 dangerouslySetInnerHTML={{ __html: kloaContent.challenge }}/><br/>
        </WholeRow>

        <WholeRow>
          <Subtitle theme={{color:"#EE0800"}}>Align research goals with business goals</Subtitle>
          <H5 dangerouslySetInnerHTML={{ __html: kloaContent.aligngoals1 }}/>
          <OuterFlexBox>
            <H5 light theme={{widthM:"47%", widthS: "100%"}} dangerouslySetInnerHTML={{ __html: kloaContent.strategy1 }}/>
            <H5 light theme={{widthM:"47%", widthS: "100%"}} dangerouslySetInnerHTML={{ __html: kloaContent.strategy2 }}/>
          </OuterFlexBox><br/>
          <H5 dangerouslySetInnerHTML={{ __html: kloaContent.aligngoals2 }}/>
        </WholeRow>

        <WholeRow>
          <Title>Research Process</Title>
          <H5 dangerouslySetInnerHTML={{ __html: kloaContent.researchoverview }}/>
          <Subtitle theme={{color:"#EE0800"}}>Understand the construction industry</Subtitle>
          <OuterFlexBox>
            <H5 light theme={{widthM:"30%", widthS: "100%"}} dangerouslySetInnerHTML={{ __html: kloaContent.interview_goal }}/>
            <H5 light theme={{widthM:"30%", widthS: "100%"}} dangerouslySetInnerHTML={{ __html: kloaContent.interview_method }}/>
            <H5 light theme={{widthM:"30%", widthS: "100%"}} dangerouslySetInnerHTML={{ __html: kloaContent.interview_p }}/>
          </OuterFlexBox>
        </WholeRow>
        <div>
          <Subtitle>Desk research</Subtitle>
          <H5 dangerouslySetInnerHTML={{ __html: kloaContent.deskresearch }}/><br/>
        </div>
        <Image src={kloaContent.cmodelimg} alt={kloaContent.cmodelimg} style={{"width":"100%"}}/>
        <WholeRow>
        <Subtitle>Preliminary interview</Subtitle>
        <H5 dangerouslySetInnerHTML={{ __html: kloaContent.interview }}/>
        <H5 light dangerouslySetInnerHTML={{ __html: kloaContent.interview_rq }}/>

        <br/>
        <Subtitle>Actionable insights for the next step</Subtitle>
        <H5 dangerouslySetInnerHTML={{ __html: kloaContent.insight1 }}/>
        </WholeRow>

        <WholeRow>
        <Subtitle theme={{color:"#EE0800"}}>Indentify opportunities for KLOA</Subtitle>
        <OuterFlexBox>
          <H5 light theme={{widthM:"30%", widthS: "100%"}} dangerouslySetInnerHTML={{ __html: kloaContent.interview_goal2 }}/>
          <H5 light theme={{widthM:"30%", widthS: "100%"}} dangerouslySetInnerHTML={{ __html: kloaContent.interview_method }}/>
          <H5 light theme={{widthM:"30%", widthS: "100%"}} dangerouslySetInnerHTML={{ __html: kloaContent.interview_p2 }}/>
        </OuterFlexBox>
        <br/>
        <H5>RESEARCH QUESTIONS</H5>
        <H5 light dangerouslySetInnerHTML={{ __html: kloaContent.interview_rq2 }}/>
        <br/>
        <H5>CURRENT FINDINGS</H5>
        <OuterFlexBox>
          <H5 light theme={{widthM:"30%", widthS: "100%"}} dangerouslySetInnerHTML={{ __html: kloaContent.finding21 }}/>
          <H5 light theme={{widthM:"30%", widthS: "100%"}} dangerouslySetInnerHTML={{ __html: kloaContent.finding22 }}/>
          <H5 light theme={{widthM:"30%", widthS: "100%"}} dangerouslySetInnerHTML={{ __html: kloaContent.finding23 }}/>
        </OuterFlexBox>
        <H5 light dangerouslySetInnerHTML={{ __html: kloaContent.findings1 }}/>

        </WholeRow>

        <WholeRow>
          <Title>IMPACTS</Title>
          <H3 theme={{color:"#EE0800"}} dangerouslySetInnerHTML={{ __html: kloaContent.impacts }}/>
        </WholeRow>
        <WholeRow>
          <Title>Learnings and Next Steps</Title>
          <H5 dangerouslySetInnerHTML={{ __html: kloaContent.learning }}/>
          <H5 dangerouslySetInnerHTML={{ __html: kloaContent.nextstep }}/>
        </WholeRow>**/}
        <br/><br/>
        <WholeRow><Footer/></WholeRow>
          <NextBtn  theme={{color:"#EE0800", shadow: "rgba(238, 8, 0, 0.3)"}} to={kloaContent.link}>
            <CgArrowLongRight/>
          </NextBtn>
      </ShContainer>

      </OuterContainer>
      </div>
    );
  }
}

export default Kloa;
